export default {"src":"/_next/static/media/IN.333f8921.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};